// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/search/v1/sort.proto" (package "c1.api.search.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.search.v1.SortOptions
 */
export interface SortOptions {
    /**
     * @generated from protobuf field: string order_by = 1;
     */
    orderBy: string;
    /**
     * @generated from protobuf field: bool descending = 2;
     */
    descending: boolean;
}
/**
 * @generated from protobuf enum c1.api.search.v1.SortDirection
 */
export enum SortDirection {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    DESC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SortOptions$Type extends MessageType<SortOptions> {
    constructor() {
        super("c1.api.search.v1.SortOptions", [
            { no: 1, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "descending", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.SortOptions
 */
export const SortOptions = new SortOptions$Type();
